module.exports = __webpack_public_path__ + "img/wesettle2.ea29c058.png";